<template>
  <div class="combo-form">
    <div class="animated fadeIn">
      <b-row>
        <b-col cols="10">
          <div class="form-group row header-custom-switch">
            <legend class="col-sm-12 col-form-label uppercase">
              <strong>
                <h3>
                  <router-link :to="{ name: 'combo_list'}" class="float-left mr-1 main-link">{{$t('combo.combos')}}</router-link>
                  <span class="float-left mr-1 main-link">/</span>
                  <router-link :to="{ name: 'combo_edit',  params: { uuid: item.combo_uuid }}" class="float-left mr-1 main-link">{{$t('combo.detail')}}</router-link>
                  / {{$t('combo.group_information')}}
                </h3>
              </strong>
              <span class="text-main">
                <router-link :to="{ name: 'update_combo_group',  params: { uuid: item.combo_uuid }}" class="float-left mr-1 main-link">{{$t('common.new_ui')}}</router-link>
              </span>
            </legend>
          </div>
        </b-col>
        <b-col cols="2">
          <div class="form-group row mb-0 pt-10 pull-right mr-0" v-show="combo.config.more_group">
            <b-button variant="primary" class="border-radius-4px bg-main" v-on:click="addComboGroup"><i class="fa fa-plus"></i>&nbsp; {{$t('common.new')}}</b-button>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <b-card header-tag="header" footer-tag="footer">
            <div v-for="(group, g) in item.groups" :key="group.id">
              <input type="hidden" name="groupUUID" v-model="group.uuid">
              <div slot="header" class="card-header" @click="updateGroupStatus($event,g)" v-b-toggle="'group_content_'+g">
                  <i className="group-header fa fa-align-justify"></i>
                  <strong>{{ group.name[$session.get('lang')] || $t('combo.group') + ' ' + (g+1) }}</strong>
                <label class="switch switch-sm switch-text switch-info float-right" >
                  <i class="fa fa-sort-down" v-if="groupStatus[g]"></i>
                  <i class="fa fa-sort-up" v-if="!groupStatus[g]"></i>
                </label>
              </div>
              <b-collapse :visible.sync="groupStatus[g]" :id="'group_content_'+g">
                <b-row>
                  <b-card class="col-12">
                    <b-row class="form-group">
                      <b-col cols="6">
                        <div class="form-row">
                          <legend class="col-sm-3 col-form-label ">{{$t('combo.marketing_name')}}</legend>
                          <div v-for="(lang,lidx) in $store.getters.languages" class="col-sm-9"  :key="lang.id" v-if="lidx == 0">
                            <b-form-input type="text"
                                          :name="`name[${lang}]`"
                                          class="form-control border-radius-4px"
                                          v-model="group.name[lang]"
                                          v-bind:placeholder="$t('common.text_' + lang)"
                            />
                          </div>
                        </div>
                      </b-col>
                      <b-col cols="6">
                        <div class="form-row">
                          <div v-for="(lang,lidx) in $store.getters.languages" class="col-sm-9"  :key="lang.id" v-if="lidx > 0">
                            <b-form-input type="text"
                                          :name="`name[${lang}]`"
                                          class="form-control border-radius-4px"
                                          v-model="group.name[lang]"
                                          v-bind:placeholder="$t('common.text_' + lang)"
                            />
                          </div>
                          <b-col cols="3" class="form-row">
                            <b-button variant="primary" class="border-radius-4px bg-main col-sm-10" v-on:click="addItem(g)" v-show="combo.config.more_item"><i class="fa fa-plus"></i>&nbsp; {{$t('combo.menu_item')}}</b-button>
                            <b-col cols="2" class="text-right remove-section" v-show="combo.config.more_group">
                              <i class="fa fa-trash-o text-main pointer" @click="removeGroup(g)"></i>
                            </b-col>
                          </b-col>
                        </div>
                      </b-col>
                    </b-row>
                    <!-- Basic information -->
                    <b-row>
                        <b-col cols="6">
                            <input type="hidden" name="combo_id" :value="item.combo_id">
                          <b-form-group v-bind:label="$t('combo.name_seo')" :label-cols="3" :horizontal="true">
                            <b-form-input
                                    type="text"
                                    class="form-control border-radius-4px "
                                    v-model="group.name_seo"
                            />
                          </b-form-group>

                          <b-form-group v-bind:label="$t('combo.min_group')" :label-cols="3" :horizontal="true" class="hide">
                                <b-form-input
                                    type="number"
                                    class="form-control border-radius-4px"
                                    v-model="group.min"
                                    :state="minState(g)"
                                    :aria-describedby="'min-feedback'"/>
                                <b-form-invalid-feedback :id="'min-feedback'">
                                    {{ $t('message.required_filed') }}
                                </b-form-invalid-feedback>
                            </b-form-group>

                            <b-form-group v-bind:label="$t('combo.max_group')" :label-cols="3" :horizontal="true" class="hide">
                                <b-form-input
                                    type="number"
                                    class="form-control border-radius-4px "
                                    v-model="group.max"
                                    :state="maxState(g)"
                                    :aria-describedby="'max-feedback'"/>
                                <b-form-invalid-feedback :id="'max-feedback'">
                                  {{ $t('message.required_filed') }}
                                </b-form-invalid-feedback>
                            </b-form-group>

                            <b-form-group v-bind:label="$t('combo.sequence')" :label-cols="3" :horizontal="true">
                                <b-form-input
                                    type="number"
                                    class="form-control border-radius-4px "
                                    v-model="group.sequence"
                                    :state="sequenceState(g)"
                                    :aria-describedby="'sequence-feedback'"/>
                                    <b-form-invalid-feedback :id="'sequence-feedback'">
                                        {{ $t('message.required_filed') }}
                                    </b-form-invalid-feedback>
                            </b-form-group>

                          <b-form-group v-bind:label="$t('combo.show_ui')" :label-cols="3" :horizontal="true" class="hide">
                            <c-switch type="icon" variant="primary" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true" v-model="group.active" :value="1" :uncheckedValue="0"/>
                          </b-form-group>

                          <b-form-group v-bind:label="$t('combo.half_half')" :label-cols="3" :horizontal="true">
                            <c-switch type="icon" variant="primary" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true" v-model="group.has_half_half" :value="1" :uncheckedValue="0"/>
                          </b-form-group>

                        </b-col>
                        <!-- Images -->
                        <b-col cols="6" class="hide">
                            <b-row>
                                <b-col cols="4" v-for="(data, image) in group.imageData" :key="data.id">
                                    <b-form-group v-bind:label="$t(image)" >
                                      <b-form-file v-model="group.imageData[image]" :id="image" @change="previewImageComboGroup(g, $event)" accept="image/*"></b-form-file>
                                    </b-form-group>
                                    <div v-bind:class="'image-' + image + '-preview img-min-height'">
                                      <img class="preview-image" v-bind:src="data">
                                    </div>
                                    <hr/>
                                </b-col>
                            </b-row>
                        </b-col>
                    </b-row>
                    <!-- item information -->
                    <!-- (item, i) in item.groups[g].items -->
                    <b-row v-for="(itemGroup, i) in group.items" :key="itemGroup.id">
                      <!--{{itemGroup}}-->
                        <b-card class="menu-item-content border-none">
                          <!-- select menu item to add into combo group -->
                          <div  slot="header"   >
                            <b-row class="menu-item-ddl form-group">
                              <legend class="col-sm-1 col-form-label">{{$t('combo.menu_item')}}</legend>
                               <!--<model-select class="col-sm-8"-->
                                             <!--:options="menuItems[$session.get('lang')]"-->
                                            <!--:customAttr="modelCustomAttr()" :placeholder="itemGroup.single.selling_start"-->
                                            <!--:id="'menu-item'"-->
                                            <!--v-model="group.menuItemSelected[i]"-->
                                            <!--v-on:input="changeMenuItem(g, i)"-->
                              <!--&gt;-->
                               <!--</model-select>-->
                              <multiselect style="width: 50%" v-model="group.menuItemSelected[i]" label="text"
                                           track-by="text" :options="menuItems[$session.get('lang')]"
                                           @input="changeMenuItem(g, i)"
                                           :hideSelected="true"
                                           :show-labels="false">
                                <template v-if="props.option.value.length > 0" slot="singleLabel" slot-scope="props">
                                  <span>{{props.option.text}}</span>
                                </template>
                                <template v-if="props.option.value.length > 0" slot="option" slot-scope="props"><span>{{props.option.name}} | <span style="color: #6200EE">{{props.option.sku}}</span></span>
                                  <div class="option__desc">
                                    <!--<span class="option__title">{{ props.option.value }}-->
                                  <!--</span>-->
                                  <span style="font-size: 10px; color: #424242" class="option__small" v-if="props.option.value.length > 0">
                                        {{'Selling start: ' + props.option.selling_start + ' - ' + props.option.selling_end}}
                                  </span></div>
                                </template>
                              </multiselect>
                              <div class="col-sm-1 copy-section">
                                <i class="fa fa-files-o text-main pointer" @click="copySku(g, i)"></i>
                              </div>
                              <div class="col-sm-1 remove-section">
                                <i class="fa fa-trash-o text-main pointer" @click="removeItem(g, i)" v-show="combo.config.more_item"></i>
                              </div>
                              <label class="col-sm-1 switch switch-sm switch-text switch-info float-right" @click="updateGroupItemStatus($event,g,i)" v-b-toggle="'group_item_content_'+g+'_'+i">
                                <i class="fa fa-sort-down float-right " v-if="groupItemStatus[g][i]"></i>
                                <i class="fa fa-sort-up float-right " v-if="!groupItemStatus[g][i]"></i>
                              </label>
                            </b-row>
                          </div>
                          <b-collapse :visible.sync="groupItemStatus[g][i]" :id="'group_item_content_'+g+'_'+i">
                            <!-- opening hours and special date -->
                            <b-row v-if="group.menuItemSelected[i] && combo.config.opening_hours">
                                <b-col cols="4">
                                    <h4 class="title">{{$t('combo.available')}}</h4>
                                </b-col>
                            </b-row>

                            <!-- Part of Days of Week -->
                            <b-row v-if="group.menuItemSelected[i]">
                                <b-col cols="4" v-if="combo.config.opening_hours">
                                  <b-form-group :label-cols="3" :horizontal="true" v-for="day in daysOfWeek" :key="day.id" v-bind:label="$t(day)">
                                    <div role="group" class="input-group">
                                        <!-- debug here -->
                                      <div class="input-group-append">
                                        <div class="input-group-text">
                                          <b-form-checkbox v-model="itemGroup.opening_times[day].active" :value="1" :unchecked-value="0"></b-form-checkbox>
                                        </div>
                                      </div>
                                      <masked-input
                                        type="text"
                                        name="date"
                                        class="form-control col-sm-6 float-left"
                                        v-model="itemGroup.opening_times[day].opening"
                                        :mask="[/\d/, /\d/, ':', /\d/, /\d/, ':', '0', '0']"
                                        :guide="true"
                                        placeholderChar="_"
                                        :showMask="true"
                                        :keepCharPositions="true">
                                      </masked-input>
                                      <div class="input-group-append">
                                        <div class="input-group-text"><i class="fa fa-minus"></i></div>
                                      </div>
                                      <masked-input
                                        type="text"
                                        name="date"
                                        class="form-control col-sm-6 float-left"
                                        v-model="itemGroup.opening_times[day].closing"
                                        :mask="[/\d/, /\d/, ':', /\d/, /\d/, ':', '0', '0']"
                                        :guide="true"
                                        placeholderChar="_"
                                        :showMask="true"
                                        :keepCharPositions="true">
                                      </masked-input>
                                    </div>
                                  </b-form-group>
                                </b-col>
                                <!-- End of Days of Week -->

                                <!-- Part of Special Date -->
                                <b-col cols="8" v-if="false">
                                  <b-form-group :label-cols="11" v-bind:label="$t('combo.special_date')">
                                    <table class="table table-bordered table-hover">
                                      <thead>
                                      <tr>
                                        <th>{{$t('combo.name')}}</th>
                                        <th>{{$t('combo.date')}}</th>
                                        <th>{{$t('combo.time')}}</th>
                                        <th>{{$t('combo.open')}}</th>
                                        <th>{{$t('combo.active')}}</th>
                                        <th>{{$t('combo.action')}}</th>
                                      </tr>
                                      </thead>
                                      <tbody>
                                        <tr v-for="(date, index) in itemGroup.special_dates" :key="date.id">
                                        <td>
                                          <b-form-input class="form-control" v-model="itemGroup.special_dates[index].name">
                                          </b-form-input>
                                        </td>
                                        <td>
                                          <masked-input
                                            type="text"
                                            name="date"
                                            class="form-control"
                                            v-model="itemGroup.special_dates[index].date"
                                            :mask="[/\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]"
                                            :guide="true"
                                            placeholderChar="_"
                                            :showMask="true"
                                            :keepCharPositions="true">
                                          </masked-input>
                                        </td>
                                        <td>
                                          <div role="group" class="input-group">
                                            <masked-input
                                              type="text"
                                              name="date"
                                              class="form-control col-sm-6 float-left"
                                              v-model="itemGroup.special_dates[index].from"
                                              :mask="[/\d/, /\d/, ':', /\d/, /\d/, ':', '0', '0']"
                                              :guide="true"
                                              placeholderChar="_"
                                              :showMask="true"
                                              :keepCharPositions="true">
                                            </masked-input>
                                            <div class="input-group-append">
                                              <div class="input-group-text"><i class="fa fa-minus"></i></div>
                                            </div>
                                            <masked-input
                                              type="text"
                                              name="date"
                                              class="form-control col-sm-6 float-left"
                                              v-model="itemGroup.special_dates[index].to"
                                              :mask="[/\d/, /\d/, ':', /\d/, /\d/, ':', '0', '0']"
                                              :guide="true"
                                              placeholderChar="_"
                                              :showMask="true"
                                              :keepCharPositions="true">
                                            </masked-input>
                                          </div>
                                        </td>
                                        <td>
                                          <c-switch type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true" v-model="itemGroup.special_dates[index].status" :checked="itemGroup.special_dates[index].status" :value="1" :uncheckedValue="0"/>
                                        </td>
                                        <td>
                                          <c-switch type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true" v-model="itemGroup.special_dates[index].active" :checked="itemGroup.special_dates[index].active" :value="1" :uncheckedValue="0"/>
                                        </td>
                                        <td>
                                          <b-button variant="danger" v-on:click="removeSpecialDate(g, i, index)" size="sm" v-show="combo.config.special_date"><i class="fa fa-trash-o"></i></b-button>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td colspan="6">
                                          <b-button variant="success" v-on:click="addSpecialDate(g, i)" v-show="combo.config.special_date"><i class="fa fa-plus"></i></b-button>
                                        </td>
                                      </tr>
                                      </tbody>
                                    </table>
                                  </b-form-group>
                                </b-col>
                                <!-- End of Special Date -->
                            </b-row>
                          <!-- Part of Single Layers -->

                          <!-- Part of Single Price -->
                            <b-row v-if="group.menuItemSelected[i] && combo.config.single_price">
                              <div class="col-sm-2">{{$t('combo.price')}}({{currency.symbol}})</div>
                              <div class="size-price-input col-sm-10" v-if="_.size(tier) <= 1 && combo.config.single_multi_price != true && combo.config.product_tax_price != true">
                                <div class="full-width" v-for="(price, p) in itemGroup.prices" :key="price.id">
                                  <input type="hidden" class="form-control" v-model="itemGroup.prices[p].active"/>
                                  <input type="hidden" class="form-control" v-model="itemGroup.prices[p].from"/>
                                  <input type="hidden" class="form-control" v-model="itemGroup.prices[p].to"/>
                                  <input type="hidden" class="form-control" v-model="itemGroup.prices[p].tax_rate"/>
                                  <div v-for="(name, index) in tier" class="full-width">
                                    <b-form-input type="number" min="0" class="form-control border-radius-4px" v-model="itemGroup.prices[p].price[index]" v-bind:placeholder="$t('combo.price')" :disabled="checkDisableByConfig('single', 'price')">
                                    </b-form-input>
                                    <input type="hidden" class="form-control" v-model="itemGroup.prices[p].price_without_tax[index]"/>
                                  </div>
                                </div>
                              </div>
                              <div class="size-price-input col-sm-10" v-if="_.size(tier) > 1 ||  combo.config.single_multi_price == true || combo.config.product_tax_price == true">
                                <button type="button" class="btn bg-main border-radius-4px" v-on:click="showModal('menu_'+g+'_'+i)">
                                  {{$t('combo.edit_price')}}
                                </button>
                                <!-- the prices modal -->
                                <b-modal :id="'menu_'+g+'_'+i" centered :title="$t('combo.item_price')+ '('+currency.symbol+')'">
                                  <div class="row" v-if="combo.config.single_multi_price">
                                    <div class="col-sm-12 mb-2 text-main">
                                      <span class="button-text" @click="addPriceToSingle(g, i)" ><i class="fa fa-plus"></i> {{$t('common.add')}}</span>
                                    </div>
                                  </div>

                                  <div class="full-width" v-for="(price, p) in itemGroup.prices" :key="price.id">
                                    <input type="hidden" class="form-control" v-model="itemGroup.prices[p].active"/>
                                    <div class="row bg-secondary py-2 d-flex" v-if="combo.config.single_multi_price">
                                      <div class="d-flex flex-1 px-3">
                                        <div class="size-label">{{$t('combo.from')}}</div>
                                        <div class="size-code-input">
                                          <masked-input
                                            type="text"
                                            name="date"
                                            class="form-control border-radius-4px"
                                            v-model="itemGroup.prices[p].from"
                                            :mask="[/\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]"
                                            :guide="true"
                                            placeholderChar="_"
                                            :showMask="true"
                                            :keepCharPositions="true">
                                          </masked-input>
                                        </div>
                                      </div>
                                      <div class="d-flex flex-1 px-3">
                                        <div class="size-label text-right">{{$t('combo.to')}}</div>
                                        <div class="size-code-input ">
                                          <masked-input
                                            type="text"
                                            name="date"
                                            class="form-control border-radius-4px"
                                            v-model="itemGroup.prices[p].to"
                                            :mask="[/\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]"
                                            :guide="true"
                                            placeholderChar="_"
                                            :showMask="true"
                                            :keepCharPositions="true">
                                          </masked-input>
                                        </div>
                                      </div>
                                      <div class="auto-width px-3 button-text remove-section" >
                                        <i class="fa fa-trash-o text-main" @click="removePriceToSingle(g, i, p)" ></i>
                                      </div>
                                    </div>
                                    <div class="row py-2">
                                      <div class="col-sm-12" v-if="combo.config.product_tax_price">
                                        <b-form-group v-bind:label="$t('combo.tax_rate')">
                                          <input type="number" class="form-control" v-model="itemGroup.prices[p].tax_rate"/>
                                        </b-form-group>
                                      </div>
                                      <div class="col-sm-6 d-flex mb-0" v-for="(name, index) in tier">
                                        <b-card class="w-100 pb-0" v-bind:title="name ? name : $t('combo.tier') + ' ' + index">
                                          <b-form-group>
                                            <b-row>
                                              <div class="col-sm-12">
                                                <b-form-group v-bind:label="$t('combo.price')">
                                                  <b-form-input type="number" min="0" class="form-control border-radius-4px" v-model="itemGroup.prices[p].price[index]" v-bind:placeholder="$t('combo.price')" :disabled="checkDisableByConfig('single', 'price')">
                                                  </b-form-input>
                                                </b-form-group>
                                              </div>
                                              <div class="col-sm-12" v-if="combo.config.product_tax_price">
                                                <b-form-group v-bind:label="$t('combo.price_without_tax')">
                                                  <input type="number" class="form-control" v-model="itemGroup.prices[p].price_without_tax[index]"/>
                                                </b-form-group>
                                              </div>

                                            </b-row>
                                          </b-form-group>
                                        </b-card>
                                      </div>
                                    </div>
                                  </div>
                                  <div slot="modal-footer" class="full-width">
                                    <button type="button" class="btn bg-main float-right border-radius-4px" v-on:click="hideModal('menu_'+g+'_'+i)">{{$t('common.save')}}</button>
                                  </div>
                                </b-modal>
                              </div>
                              <!-- End of Single Price -->
                            </b-row>

                            <!-- select crush item to add into combo group -->
                            <b-row v-if="group.menuItemSelected[i]">
                              <div class="col-sm-2"> {{ $t('combo.crust_size') }}</div>
                              <div class="col-sm-10">
                                <span class="btn text-main add-more-size" @click="addSingleFirst(g,i)" v-show="combo.config.more_first">
                                  <i class="fa fa-plus-circle"></i> {{$t('common.add_more')}}
                                </span>
                              </div>
                              <b-form class="col-sm-12">
                                <div class="option-box" v-for="(first, f) in itemGroup.first_layers" :key="first.id">
                                  <div class="option-first">
                                    <b-row>
                                      <b-col cols="5" class="d-flex">
                                        <div class="size-label">{{$t('combo.size')}}</div>
                                        <div v-for="lang in $store.getters.languages" :key="lang.id" class="size-name-input">
                                          <b-form-input autocomplete="off" :list="'name_first_layer_list_' +lang + '_' + f" type="text" class="form-control border-radius-4px" @change="updateFirstLayerItems(g, i, f, $event, lang)" v-model="itemGroup.first_layers[f].name[lang]" v-bind:placeholder="$t('common.text_'+lang)"></b-form-input>
                                          <datalist :id="'name_first_layer_list_' + lang + '_' + f" v-if="first_layer_options.length > 0">
                                            <option v-for="first_option in first_layer_options" :key="first_option.sku" v-bind:value="first_option.name[lang]"  v-bind:label="first_option.name[lang]"></option>
                                          </datalist>
                                        </div>
                                      </b-col>

                                      <b-col cols="3" class="d-flex">
                                        <div class="size-label">{{$t('combo.code')}}</div>
                                        <div class="size-code-input">
                                          <b-form-input autocomplete="off" :list="'sku_first_layer_list_'+ '_' + f" type="text" class="form-control border-radius-4px" @change="updateFirstLayerItems(g, i, f, $event)"  v-model="itemGroup.first_layers[f].sku"/>
                                          <datalist :id="'sku_first_layer_list_'+  '_' + f" v-if="first_layer_options.length > 0">
                                            <option v-for="first_option in first_layer_options" :key="first_option.sku" v-bind:value="first_option.sku"  v-bind:label="first_option.sku" ></option>
                                          </datalist>
                                        </div>
                                      </b-col>
                                      <b-col cols="2" class="d-flex" v-if="combo.config.first_price">
                                        <div class="size-label" v-if="_.size(tier) <= 1 && combo.config.single_multi_price != true">{{$t('combo.price')}} ({{currency.symbol}})</div>
                                        <div class="size-price-input" v-if="_.size(tier) <= 1 && combo.config.first_multi_price != true && combo.config.product_tax_price != true">
                                          <div class="full-width" v-for="(price, p) in itemGroup.first_layers[f].prices" :key="price.id">
                                            <input type="hidden" class="form-control" v-model="itemGroup.first_layers[f].prices[p].active"/>
                                            <input type="hidden" class="form-control" v-model="itemGroup.first_layers[f].prices[p].from"/>
                                            <input type="hidden" class="form-control" v-model="itemGroup.first_layers[f].prices[p].to"/>
                                            <input type="hidden" class="form-control" v-model="itemGroup.first_layers[f].prices[p].tax_rate"/>
                                            <div v-for="(name, index) in tier" class="full-width">
                                              <b-form-input type="number" min="0" class="form-control border-radius-4px" v-model="itemGroup.first_layers[f].prices[p].price[index]" v-bind:placeholder="$t('combo.price')" :disabled="checkDisableByConfig('first', 'price')">
                                              </b-form-input>
                                              <input type="hidden" class="form-control" v-model="itemGroup.first_layers[f].prices[p].price_without_tax[index]"/>
                                            </div>
                                          </div>
                                        </div>
                                        <div class="size-price-input" v-if="_.size(tier) > 1 || combo.config.first_multi_price == true || combo.config.product_tax_price == true">
                                          <button type="button" class="btn bg-main border-radius-4px" v-on:click="showModal('first_'+g+'_'+i+'_'+f)">
                                            {{$t('combo.edit_price')}}
                                          </button>
                                          <!-- the prices modal -->
                                          <b-modal :id="'first_'+g+'_'+i+'_'+f" centered :title="$t('combo.size_price')+'('+currency.symbol+')'">
                                            <div class="row" v-if="combo.config.first_multi_price">
                                              <div class="col-sm-12 mb-2 text-main">
                                                <span class="button-text" @click="addPriceToSingleFirst(g,i,f)"><i class="fa fa-plus"></i> {{$t('common.add')}}</span>
                                              </div>
                                            </div>
                                            <div class="full-width" v-for="(price, p) in itemGroup.first_layers[f].prices" :key="price.id">
                                              <input type="hidden" class="form-control" v-model="itemGroup.first_layers[f].prices[p].active"/>
                                              <div class="row bg-secondary py-2 d-flex" v-if="combo.config.first_multi_price">
                                                <div class="d-flex flex-1 px-3">
                                                  <div class="size-label">{{$t('combo.from')}}</div>
                                                  <div class="size-code-input">
                                                    <masked-input
                                                      type="text"
                                                      name="date"
                                                      class="form-control border-radius-4px"
                                                      v-model="itemGroup.first_layers[f].prices[p].from"
                                                      :mask="[/\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]"
                                                      :guide="true"
                                                      placeholderChar="_"
                                                      :showMask="true"
                                                      :keepCharPositions="true">
                                                    </masked-input>
                                                  </div>
                                                </div>
                                                <div class="d-flex flex-1 px-3">
                                                  <div class="size-label text-right">{{$t('combo.to')}}</div>
                                                  <div class="size-code-input">
                                                    <masked-input
                                                      type="text"
                                                      name="date"
                                                      class="form-control border-radius-4px"
                                                      v-model="itemGroup.first_layers[f].prices[p].to"
                                                      :mask="[/\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]"
                                                      :guide="true"
                                                      placeholderChar="_"
                                                      :showMask="true"
                                                      :keepCharPositions="true">
                                                    </masked-input>
                                                  </div>
                                                </div>
                                                <div class="auto-width px-3 button-text remove-section" >
                                                  <i class="fa fa-trash-o text-main" @click="removePriceToSingleFirst(g, i, f, p)" ></i>
                                                </div>
                                              </div>
                                              <div class="row py-2">
                                                <div class="col-sm-12" v-if="combo.config.product_tax_price">
                                                  <b-form-group v-bind:label="$t('combo.tax_rate')">
                                                    <input type="number" class="form-control" v-model="itemGroup.first_layers[f].prices[p].tax_rate"/>
                                                  </b-form-group>
                                                </div>
                                                <div class="col-sm-6 d-flex mb-0" v-for="(name, index) in tier">
                                                  <b-card class="w-100 pb-0" v-bind:title="name ? name : $t('combo.tier') + ' ' + index">
                                                    <b-form-group>
                                                      <b-row>
                                                        <div class="col-sm-12">
                                                          <b-form-group v-bind:label="$t('combo.price')">
                                                            <b-form-input type="number" min="0" class="form-control border-radius-4px" v-model="itemGroup.first_layers[f].prices[p].price[index]" v-bind:placeholder="$t('combo.price')" :disabled="checkDisableByConfig('first', 'price')">
                                                            </b-form-input>
                                                          </b-form-group>
                                                        </div>
                                                        <div class="col-sm-12" v-if="combo.config.product_tax_price">
                                                          <b-form-group v-bind:label="$t('combo.price_without_tax')">
                                                            <input type="number" class="form-control" v-model="itemGroup.first_layers[f].prices[p].price_without_tax[index]"/>
                                                          </b-form-group>
                                                        </div>
                                                      </b-row>
                                                    </b-form-group>
                                                  </b-card>
                                                </div>
                                              </div>
                                            </div>
                                            <div slot="modal-footer" class="full-width">
                                              <button type="button" class="btn bg-main float-right border-radius-4px" v-on:click="hideModal('first_'+g+'_'+i+'_'+f)">{{$t('common.save')}}</button>
                                            </div>
                                          </b-modal>
                                        </div>
                                      </b-col>
                                      <b-col cols="1">
                                        <c-switch type="icon" variant="primary"  v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true" v-model="itemGroup.first_layers[f].active" :value="1" :uncheckedValue="0"/>
                                      </b-col>
                                      <b-col cols="1">
                                        <b-button variant="primary" class="border-radius-4px bg-main" v-on:click="addSingleSecond(g, i, f)" v-show="combo.config.more_second"><i class="fa fa-plus"></i>&nbsp; {{$t('combo.crust')}}</b-button>
                                      </b-col>
                                      <b-col cols="1">
                                        <i class="fa fa-trash-o text-main pointer" @click="removeSingeFirst(g, i, f)"  v-show="combo.config.more_first"></i>
                                      </b-col>
                                    </b-row>
                                  </div>
                                  <div class="option-second">
                                    <div class="row">
                                      <div class="col-lg-4 col-md-6" v-for="(second, s) in first.second_layers" :key="second.id">
                                        <div class="second-box">
                                          <div class="second-header">
                                            <span class="text-main font-weight-600"><c-switch type="icon" variant="primary" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true" v-model="itemGroup.first_layers[f].second_layers[s].active" :value="1" :uncheckedValue="0"/></span>
                                            <span class="close-btn" @click="removeSingeSecond(g, i, f, s)"  v-show="combo.config.more_second">
                                              <i class="fa fa-trash-o text-main"></i>
                                            </span>
                                          </div>
                                          <b-form-group v-for="lang in $store.getters.languages" label-class="hidden" :key="lang.id">
                                            <b-form-input autocomplete="off" :list="'name_second_layer_list_' + lang + '_' + f + '_' + s" @change="updateSecondLayerItems(g, i, f, s, $event, lang)"  type="text" class="form-control border-radius-4px" v-model="itemGroup.first_layers[f].second_layers[s].name[lang]" v-bind:placeholder="$t('common.text_'+lang)"/>
                                            <datalist :id="'name_second_layer_list_' + lang + '_' + f + '_' + s" v-if="first_layer_options.length > 0 && second_layer_options.length > 0">
                                              <option v-for="second_option in second_layer_options" :key="second_option.sku" v-bind:value="second_option.name[lang]"  v-bind:label="second_option.name[lang]" ></option>
                                            </datalist>
                                          </b-form-group>
                                          <div class="full-width d-flex">
                                            <div class="size-label">{{$t('combo.code')}}</div>
                                            <div class="size-code-input no-padding">
                                              <b-form-input type="text" class="form-control border-radius-4px" v-model="itemGroup.first_layers[f].second_layers[s].sku"/>
                                            </div>
                                          </div>
                                          <div class="full-width d-flex mt-3">
                                            <div class="size-label" v-if="_.size(tier) <= 1 && combo.config.second_price != true">{{$t('combo.price')}} ({{currency.symbol}})</div>
                                            <div class="flex-1" v-if="_.size(tier) <= 1 && combo.config.second_multi_price != true && combo.config.product_tax_price != true">
                                              <div class="full-width" v-for="(price, p) in itemGroup.first_layers[f].second_layers[s].prices" :key="price.id">
                                                <input type="hidden" class="form-control" v-model="itemGroup.first_layers[f].second_layers[s].prices[p].active"/>
                                                <input type="hidden" class="form-control" v-model="itemGroup.first_layers[f].second_layers[s].prices[p].from"/>
                                                <input type="hidden" class="form-control" v-model="itemGroup.first_layers[f].second_layers[s].prices[p].to"/>
                                                <input type="hidden" class="form-control" v-model="itemGroup.first_layers[f].second_layers[s].prices[p].tax_rate"/>
                                                <div v-for="(name, index) in tier" class="full-width">
                                                  <b-form-input type="number" min="0" class="form-control border-radius-4px" v-model="itemGroup.first_layers[f].second_layers[s].prices[p].price[index]" v-bind:placeholder="$t('combo.price')" :disabled="checkDisableByConfig('second', 'price')">
                                                  </b-form-input>
                                                  <input type="hidden" class="form-control" v-model="itemGroup.first_layers[f].second_layers[s].prices[p].price_without_tax[index]"/>
                                                </div>
                                              </div>
                                            </div>
                                            <div class="flex-1" v-if="_.size(tier) > 1 || combo.config.second_multi_price == true || combo.config.product_tax_price == true">
                                              <button type="button" class="btn bg-main border-radius-4px" @click="showModal('second_'+g+'_'+i+'_'+f+'_'+s)">{{$t('combo.edit_price')}}</button>
                                            </div>
                                            <div class="flex-1 pt-5px pl-10px">

                                            </div>
                                          </div>
                                          <b-modal :id="'second_'+g+'_'+i+'_'+f+'_'+s" centered :title="$t('combo.crust_price')+'('+currency.symbol+')'">
                                            <div class="row" v-if="combo.config.second_multi_price">
                                              <div class="col-sm-12 mb-2 text-main">
                                                <span class="button-text border-radius-4px" @click="addPriceToSingleSecond(g, i, f, s)"><i class="fa fa-plus"></i> {{$t('common.add')}}</span>
                                              </div>
                                            </div>

                                            <div class="full-width" v-for="(price, p) in itemGroup.first_layers[f].second_layers[s].prices" :key="price.id">
                                              <input type="hidden" class="form-control" v-model="itemGroup.first_layers[f].second_layers[s].prices[p].active"/>
                                              <div class="row bg-secondary py-2 d-flex" v-if="combo.config.second_multi_price">
                                                <div class="d-flex flex-1 px-3">
                                                  <div class="size-label">{{$t('combo.from')}}</div>
                                                  <div class="size-code-input">
                                                    <masked-input
                                                      type="text"
                                                      name="date"
                                                      class="form-control border-radius-4px"
                                                      v-model="itemGroup.first_layers[f].second_layers[s].prices[p].from"
                                                      :mask="[/\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]"
                                                      :guide="true"
                                                      placeholderChar="_"
                                                      :showMask="true"
                                                      :keepCharPositions="true">
                                                    </masked-input>
                                                  </div>
                                                </div>
                                                <div class="d-flex flex-1 px-3">
                                                  <div class="size-label text-right">{{$t('combo.to')}}</div>
                                                  <div class="size-code-input">
                                                    <masked-input
                                                      type="text"
                                                      name="date"
                                                      class="form-control border-radius-4px"
                                                      v-model="itemGroup.first_layers[f].second_layers[s].prices[p].to"
                                                      :mask="[/\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]"
                                                      :guide="true"
                                                      placeholderChar="_"
                                                      :showMask="true"
                                                      :keepCharPositions="true">
                                                    </masked-input>
                                                  </div>
                                                </div>
                                                <div class="auto-width px-3 button-text" >
                                                  <i class="fa fa-trash-o text-main" @click="removePriceToSingleSecond(g,i,f,s, p)"></i>
                                                </div>
                                              </div>
                                              <div class="row py-2">
                                                <div class="col-sm-12" v-if="combo.config.product_tax_price">
                                                  <b-form-group v-bind:label="$t('combo.tax_rate')">
                                                    <input type="number" class="form-control" v-model="itemGroup.first_layers[f].second_layers[s].prices[p].tax_rate"/>
                                                  </b-form-group>
                                                </div>
                                                <div class="col-sm-6 d-flex mb-0" v-for="(name, index) in tier">
                                                  <b-card class="w-100 pb-0" v-bind:title="name ? name : $t('combo.tier') + ' ' + index">
                                                    <b-form-group>
                                                      <b-row>
                                                        <div class="col-sm-12">
                                                          <b-form-group v-bind:label="$t('combo.price')">
                                                            <b-form-input type="number" min="0" class="form-control border-radius-4px" v-model="itemGroup.first_layers[f].second_layers[s].prices[p].price[index]" v-bind:placeholder="$t('combo.price')" :disabled="checkDisableByConfig('second', 'price')">
                                                            </b-form-input>
                                                          </b-form-group>
                                                        </div>
                                                        <div class="col-sm-12" v-if="combo.config.product_tax_price">
                                                          <b-form-group v-bind:label="$t('combo.price_without_tax')">
                                                            <input type="number" class="form-control" v-model="itemGroup.first_layers[f].second_layers[s].prices[p].price_without_tax[index]"/>
                                                          </b-form-group>
                                                        </div>
                                                      </b-row>
                                                    </b-form-group>
                                                  </b-card>
                                                </div>
                                              </div>
                                            </div>
                                            <div slot="modal-footer" class="full-width">
                                              <button type="button" class="btn bg-main float-right border-radius-4px" v-on:click="hideModal('second_'+g+'_'+i+'_'+f+'_'+s)">{{$t('combo.save')}}</button>
                                            </div>
                                          </b-modal>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </b-form>
                            </b-row>
                          <!-- End of Single Layers -->
                          </b-collapse>
                        </b-card>
                    </b-row>
                    <!-- Added here -->
                    <!-- </b-collapse>
                    </b-card> -->
                    </b-card>
                  </b-row>
              </b-collapse>
            </div>
            <div slot="footer">
              <button type="button" class="btn border-radius-4px bg-main float-left" @click="$router.back()"><i class="fa fa-arrow-left"></i> {{$t('common.back')}}</button>
              <div class="text-center">
                <b-button variant="primary" class="pull-right border-radius-4px bg-main" v-on:click="finishCreateComboGroup">&nbsp; {{$t('common.save')}}</b-button>
              </div>
            </div>

          </b-card>
        </b-col>
      </b-row>
    </div>
    <div class="hidden">
      <input type="text" id="input-to-copy" style="display: none">
    </div>
  </div>
</template>

<script>
import {validationMixin} from 'vuelidate'
import {required, minLength, maxLength, between, integer, minValue } from 'vuelidate/lib/validators'
import cSwitch from '../../../components/Switch'
import vSelect from 'vue-select'
import MaskedInput from 'vue-text-mask'
import CustomizeField from '../../../components/Partials/CustomizeField'
import Tables from '../../tables/Tables'
import { ModelSelect } from 'vue-search-select'
import Multiselect from 'vue-multiselect'

const defaultDateFrom = '01-01-2008'
const defaultDateTo = '31-12-9999'
let vm = null
export default {
  name: 'ComboGroupForm',
  props: {
    uuid: {
      type: String,
      required: true
    }
  },
  components: {
    Tables,
    cSwitch,
    vSelect,
    ModelSelect,
    MaskedInput,
    CustomizeField,
    Multiselect
  },
  data: function () {
    return {
      itemLimit: 9999999,
      flagProccess: true,
      deleteGroups: [],
      comboPrice: false, // test
      addNewComboGroup: true,
      tier: this.$store.getters.config.main.tiers,
      combo: this.$store.getters.config.gms.combo,
      // images: ["desktop_thumbnail", "desktop_detail", "mobile_thumbnail", "mobile_detail"],
      currency: this.$store.getters.config.gms.currency_info,
      daysOfWeek: this.$auth.user().config.days_of_week,
      item: {
        combo_id: 0,
        combo_uuid: '',
        groups: []
      },
      menuItems: {},
      imageData: {},
      headerName: '',
      enableCrushSize: [],
      groupHidden: [],
      groupStatus: [],
      groupItemStatus: [],
      isCreate: true,
      first_layer_options: [],
      second_layer_options: [],
    }
  },
  mixins: [
    validationMixin
  ],
  validations: {
    item: {
      name: {
        required
      },
      sequence: {
        required,
        minValue: 0,
        integer
      },
      min: {
        required
      },
      max: {
        required
      }
    }
  },
  methods: {
    checkShowByConfig (layer, key) {
      if (this.combo == null) {
        return true
      }
      let config = this._.find(this.combo[layer], function (o) {
        return o.type === key
      })
      if (config == null) {
        return false
      }
      return config.show
    },
    checkDisableByConfig (layer, key) {
      if (this.item.content_status == 75) {
        return true
      }
      if (this.combo == null) {
        return false
      }
      let config = this._.find(this.combo[layer], {type: key})
      if (config == null) {
        return false
      }
      return config.disable
    },
    modelCustomAttr () {
      return () => 'selling-attr'
    },
    hideModal (el) {
      this.$root.$emit('bv::hide::modal', el)
    },
    showModal (el) {
      this.$root.$emit('bv::show::modal', el)
    },
    removePriceToSingle (group_index, item_index, price_index) {
      let layers = []
      for (let i in vm.item.groups[group_index].items[item_index].prices) {
        if (i != price_index) {
          layers.push(vm.item.groups[group_index].items[item_index].prices[i])
        }
      }
      vm.item.groups[group_index].items[item_index].prices = layers

      // enable save group button
      // vm.addNew = true
    },
    removeSingeFirst (group_index, item_index, first_index) {
      let options = {
        html: true,
        okText: vm.$t('common.delete'),
        cancelText: vm.$t('common.cancel')
      }
      vm.$dialog.confirm(vm.$t('message.delete_confirm'), options)
        .then(function (dialog) {
          let layers = []
          for (let i in vm.item.groups[group_index].items[item_index].first_layers) {
            if (i != first_index) {
              layers.push(vm.item.groups[group_index].items[item_index].first_layers[i])
            }
          }
          vm.item.groups[group_index].items[item_index].first_layers = layers

          // enable save group button
          // vm.addNew = true
        })
        .catch(function () {
        })
    },
    /**
     * remove single second layer from list by index
     * @param first index and second index
     */
    removeSingeSecond (group_index, item_index, first_index, second_index) {
      let options = {
        html: true,
        okText: vm.$t('common.delete'),
        cancelText: vm.$t('common.cancel')
      }
      vm.$dialog.confirm(vm.$t('message.delete_confirm'), options)
        .then(function (dialog) {
          let layers = []
          for (let i in vm.item.groups[group_index].items[item_index].first_layers[first_index].second_layers) {
            if (i != second_index) {
              layers.push(vm.item.groups[group_index].items[item_index].first_layers[first_index].second_layers[i])
            }
          }
          vm.item.groups[group_index].items[item_index].first_layers[first_index].second_layers = layers

          // enable save group button
          // vm.addNew = true
        })
        .catch(function () {
        })
    },
    /**
     * remove price of single layer from list by index
     * @param first index and price index
     */
    removePriceToSingleFirst (group_index, item_index, first_index, price_index) {
      let prices = []
      for (let i in vm.item.groups[group_index].items[item_index].first_layers[first_index].prices) {
        if (i != price_index) {
          prices.push(vm.item.groups[group_index].items[item_index].first_layers[first_index].prices[i])
        }
      }
      vm.item.groups[group_index].items[item_index].first_layers[first_index].prices = prices

      // enable save group button
      // vm.addNew = true
    },
    removePriceToSingleSecond (group_index, item_index, first_index, second_index, price_index) {
      let prices = []
      for (let i in vm.item.groups[group_index].items[item_index].first_layers[first_index].second_layers[second_index].prices) {
        if (i != price_index) {
          prices.push(vm.item.groups[group_index].items[item_index].first_layers[first_index].second_layers[second_index].prices[i])
        }
      }
      vm.item.groups[group_index].items[item_index].first_layers[first_index].second_layers[second_index].prices = prices

      // enable save group button
      // vm.addNew = true
    },
    /**
     * add first layer to list
     */
    addSingleFirst (group_index, item_index) {
      let price = {}
      let price_without_tax = {}
      let prices = []
      for (let t in vm.tier) {
        price[t] = 0,
        price_without_tax[t] = 0
      }
      prices.push({
        from: defaultDateFrom,
        to: defaultDateTo,
        price: price,
        price_without_tax: price_without_tax,
        tax_rate: 0,
        active: 1
      })

      let lang = {}
      for (let l in this.$store.getters.languages) {
        lang[this.$store.getters.languages[l]] = ''
      }
      vm.item.groups[group_index].items[item_index].first_layers.push({
        name: lang,
        prices: prices,
        special_dates: [],
        opening_times: [],
        second_layers: [],
        sku: '',
        image: {},
        active: 1
      })

      // enable save group button
      // vm.addNew = true
    },
    /**
     * add second layer to list
     * @param first index
     */
    addSingleSecond (group_index, item_index, first_index) {
      let price = {}
      let price_without_tax = {}
      let prices = []
      for (let t in vm.tier) {
        price[t] = 0,
        price_without_tax[t] = 0
      }
      prices.push({
        from: defaultDateFrom,
        to: defaultDateTo,
        price: price,
        price_without_tax: price_without_tax,
        tax_rate: 0,
        active: 1
      })

      let lang = {}
      for (let l in vm.$store.getters.languages) {
        lang[vm.$store.getters.languages[l]] = ''
      }
      vm.item.groups[group_index].items[item_index].first_layers[first_index].second_layers.push({
        name: lang,
        prices: prices,
        special_dates: [],
        opening_times: [],
        sku: '',
        image: {},
        active: 1
      })

      // enable save group button
      // vm.addNew = true
    },
    /**
     * add price of first layer to list
     * @param first index
     */
    addPriceToSingle (group_index, item_index) {
      let prices = {}
      let price_without_tax = {}
      for (let t in vm.tier) {
        prices[t] = 0,
        price_without_tax[t] = 0
      }
      vm.item.groups[group_index].items[item_index].prices.push({
        from: defaultDateFrom,
        to: defaultDateTo,
        price: prices,
        price_without_tax: price_without_tax,
        tax_rate: 0,
        active: 1
      })

      // enable save group button
      // vm.addNew = true
    },
    /**
     * add price of first layer to list
     * @param first index
     */
    addPriceToSingleFirst (group_index, item_index, first_index) {
      let prices = {}
      let price_without_tax = {}
      for (let t in vm.tier) {
        prices[t] = 0,
        price_without_tax[t] = 0
      }
      vm.item.groups[group_index].items[item_index].first_layers[first_index].prices.push({
        from: defaultDateFrom,
        to: defaultDateTo,
        price: prices,
        price_without_tax: price_without_tax,
        tax_rate: 0,
        active: 1
      })

      // enable save group button
      // vm.addNew = true
    },
    /**
     * add price of second layer to list
     * @param first index and second index
     */
    addPriceToSingleSecond (group_index, item_index, first_index, second_index) {
      let prices = {}
      let price_without_tax = {}
      for (let t in vm.tier) {
        prices[t] = 0,
        price_without_tax[t] = 0
      }
      vm.item.groups[group_index].items[item_index].first_layers[first_index].second_layers[second_index].prices.push({
        from: defaultDateFrom,
        to: defaultDateTo,
        price: prices,
        price_without_tax: price_without_tax,
        tax_rate: 0,
        active: 1
      })

      // enable save group button
      // vm.addNew = true
    },
    /**
     * remove special date from list
     * @param index
     */
    removeSpecialDate (group_index, item_index, index) {
      let dates = []
      for (let i in vm.item.groups[group_index].items[item_index].special_dates) {
        if (i != index) {
          dates.push(vm.item.groups[group_index].items[item_index].special_dates[i])
        }
      }
      vm.item.groups[group_index].items[item_index].special_dates = dates

      // enable save group button
      // vm.addNew = true
    },
    /**
     * add special date to list with default attribute
     */
    addSpecialDate (group_index, item_index) {
      vm.item.groups[group_index].items[item_index].special_dates.push({
        name: '',
        from: '08:00:00',
        to: '02:00:00',
        date: this.$moment().format('DD-MM-YYYY'),
        status: 1,
        active: 1
      })

      // enable save group button
      // vm.addNew = true
    },
    groupStatusObject (group_index) {
      return vm.groupStatus[group_index] ? 'fa fa-chevron-down' : 'fa fa-chevron-up'
    },
    checkName () {
      if (vm.item.name[vm.$session.get('lang')] != undefined) {
        vm.headerName = vm.item.name[vm.$session.get('lang')]
      } else {
        vm.headerName = vm.$t('combo.group_name')
      }
    },
    changeMenuItem (group_index, item_index) {
      // raise an event to change menu item
      var uuid = vm.item.groups[group_index].menuItemSelected[item_index].value
      // vm.item.groups[group_index].menuItemSelected[item_index] = uuid
      vm.groupItemStatus[group_index][item_index] = true
      this.$forceUpdate('groupItemStatus['+group_index+']'+'['+item_index+']')
      if (uuid != '') {
        var groupItem = vm.item.groups[group_index].items[item_index]
        // get menu item detail
        vm.axios.getMenuDetail(uuid, function (response) {
          // change date for opening times
          for (var i = 0; i < response.data.data.item.opening_times.length; i++) {
            let it = response.data.data.item.opening_times[i]
            groupItem.opening_times[it.day] = it
          }

          // change date for special dates
          let special_dates = []
          for (let k in response.data.data.item.special_dates) {
            special_dates.push({
              'date': response.data.data.item.special_dates[k].date,
              'active': response.data.data.item.special_dates[k].active,
              'from': response.data.data.item.special_dates[k].from,
              'name': response.data.data.item.special_dates[k].name,
              'status': response.data.data.item.special_dates[k].status,
              'to': response.data.data.item.special_dates[k].to
            })
          }
          groupItem.special_dates = special_dates

          // update single_id for the current group
          groupItem.single_id = response.data.data.item.id

          // change date for prices
          let prices = []
          let priceDefault = {}
          for (let t in vm.tier) {
            priceDefault[t] = 0
          }
          if (response.data.data.item.prices.length > 0) {
            for (let i in response.data.data.item.prices) {
              let price = []
              price['from'] = vm.convertDateFormat(response.data.data.item.prices[i].from)
              price['to'] = vm.convertDateFormat(response.data.data.item.prices[i].to)
              price['price'] = response.data.data.item.prices[i].price
              price['price_without_tax'] = response.data.data.item.prices[i].price_without_tax != null ? response.data.data.item.prices[i].price_without_tax : priceDefault
              price['tax_rate'] = response.data.data.item.prices[i].tax_rate != null ? response.data.data.item.prices[i].tax_rate : 0

              prices.push(price)
            }
          } else {
            prices.push({
              from: defaultDateFrom,
              to: defaultDateTo,
              price: priceDefault,
              price_without_tax: priceDefault,
              tax_rate: 0,
              active: 1
            })
          }
          groupItem.prices = prices

          // change date for first layers
          if (response.data.data.item.first_layers.length > 0) {
            let first_layers = response.data.data.item.first_layers
            for (let i in first_layers) {
              // prices for first layers
              if (first_layers[i].prices.length > 0) {
                for (let j in first_layers[i].prices) {
                  first_layers[i].prices[j]['from'] = vm.convertDateFormat(response.data.data.item.first_layers[i].prices[j].from)
                  first_layers[i].prices[j]['to'] = vm.convertDateFormat(response.data.data.item.first_layers[i].prices[j].to)
                  first_layers[i].prices[j]['price'] = response.data.data.item.first_layers[i].prices[j].price
                  first_layers[i].prices[j]['price_without_tax'] = response.data.data.item.first_layers[i].prices[j].price_without_tax != null ? response.data.data.item.first_layers[i].prices[j].price_without_tax : priceDefault
                  first_layers[i].prices[j]['tax_rate'] = response.data.data.item.first_layers[i].prices[j].tax_rate != null ? response.data.data.item.first_layers[i].prices[j].tax_rate : 0
                }
              } else {
                first_layers[i].prices = []
                first_layers[i].prices.push({
                  from: defaultDateFrom,
                  to: defaultDateTo,
                  price: priceDefault,
                  price_without_tax: priceDefault,
                  tax_rate: 0,
                  active: 1
                })
              }

              // prices for second_layers
              let second_layers = first_layers[i].second_layers
              for (let j in second_layers) {
                if (second_layers[j].prices.length > 0) {
                  for (let k in second_layers[j].prices) {
                    second_layers[j].prices[k]['from'] = vm.convertDateFormat(response.data.data.item.first_layers[i].second_layers[j].prices[k].from)
                    second_layers[j].prices[k]['to'] = vm.convertDateFormat(response.data.data.item.first_layers[i].second_layers[j].prices[k].to)
                    second_layers[j].prices[k]['price'] = response.data.data.item.first_layers[i].second_layers[j].prices[k].price
                    second_layers[j].prices[k]['price_without_tax'] = response.data.data.item.first_layers[i].second_layers[j].prices[k].price_without_tax != null ? response.data.data.item.first_layers[i].second_layers[j].prices[k].price_without_tax : priceDefault
                    second_layers[j].prices[k]['tax_rate'] = response.data.data.item.first_layers[i].second_layers[j].prices[k].tax_rate != null ? response.data.data.item.first_layers[i].second_layers[j].prices[k].tax_rate : 0
                  }
                } else {
                  second_layers[j].prices = []
                  second_layers[j].prices.push({
                    from: defaultDateFrom,
                    to: defaultDateTo,
                    price: priceDefault,
                    price_without_tax: priceDefault,
                    tax_rate: 0,
                    active: 1
                  })
                }
              }
              first_layers[i].second_layers = second_layers
            }
            groupItem.first_layers = first_layers
          } else {
            groupItem.first_layers = []
          }
        })
        vm.item.groups[group_index].items[item_index] = groupItem
      } else {
        let days = {}
        for (let i in vm.daysOfWeek) {
          days[vm.daysOfWeek[i]] = {
            day: vm.daysOfWeek[i],
            opening: '08:00:00',
            closing: '23:00:00',
            active: 1
          }
        }
        vm.item.groups[group_index].items[item_index]['single_id'] = ''
        vm.item.groups[group_index].items[item_index]['opening_times'] = days
        vm.item.groups[group_index].items[item_index]['special_dates'] = []
        vm.item.groups[group_index].items[item_index]['prices'] = []
        vm.item.groups[group_index].items[item_index]['first_layers'] = []
      }
      // enable save group button
      vm.groupHidden[group_index] = true
      vm.$forceUpdate('item.groups[' + group_index + '].items')
    },
    updateGroupStatus (event, group_index) {
      vm.groupStatus[group_index] = !vm.groupStatus[group_index]
      vm.groupHidden[group_index] = !!vm.groupStatus[group_index]
      this.$forceUpdate('groupStatus['+group_index+']')
    },
    updateGroupItemStatus (event, group_index, item_index) {
      vm.groupItemStatus[group_index][item_index] = !vm.groupItemStatus[group_index][item_index]
      this.$forceUpdate('groupItemStatus['+group_index+']'+'['+item_index+']')
    },
    updatePriceStatus (event, group_index, item_index) {
      vm.item.groups[group_index].priceStatus[item_index] = !vm.item.groups[group_index].priceStatus[item_index]
    },
    checkSubmit (group_index) {
      let langs = Object.keys(vm.$i18n.messages)
      let validateName = false
      let validateOther = false
      // for (let l in langs) {
      //     if (vm.item.groups[group_index].name[langs[l]] == '' || vm.item.groups[group_index].name[langs[l]] == undefined) {
      //         validateName = true
      //     }
      // }
      validateOther = !(vm.minState(group_index) && vm.maxState(group_index) && vm.sequenceState(group_index))
      return validateName || validateOther
    },
    nameState: function (group_index, lang) {
      if (vm.item.groups[group_index].name[lang] && vm.item.groups[group_index].name[lang] != '') {
        return true
      } else {
        return false
      }
    },
    minState: function (group_index) {
      if (vm.item.groups[group_index].min == 0 || vm.item.groups[group_index].min != '') {
        return true
      } else {
        return false
      }
    },
    maxState: function (group_index) {
      if (vm.item.groups[group_index].max == 0 || vm.item.groups[group_index].max != '') {
        return true
      } else {
        return false
      }
    },
    sequenceState: function (group_index) {
      if (vm.item.groups[group_index].sequence == 0 || vm.item.groups[group_index].sequence != '') {
        return true
      } else {
        return false
      }
    },
    /**
     * preview image after select
     * @param event
     */
    previewImage (event) {
      let input = event.target
      if (input.files && input.files[0]) {
        let reader = new FileReader()

        reader.onload = (e) => {
          vm.imageData[input.id] = e.target.result
        }
        let data = {}
        for (let i in vm.images) {
          data[vm.images[i]] = vm.imageData[vm.images[i]]
        }
        vm.imageData = data
        reader.readAsDataURL(input.files[0])
        vm.item.image[input.id] = input.files[0]
      }
    },
    previewImageComboGroup (group_index, event) {
      let input = event.target
      if (input.files && input.files[0]) {
        let reader = new FileReader()
        reader.onload = (e) => {
          vm.item.groups[group_index].imageData[input.id] = e.target.result
        }
        let data = {}
        for (let i in vm.images) {
          data[vm.images[i]] = vm.item.groups[group_index].imageData[vm.images[i]]
        }
        vm.item.groups[group_index].imageData = data
        reader.readAsDataURL(input.files[0])
        vm.item.groups[group_index].image[input.id] = input.files[0]
      }
    },
    addComboGroup () {
      // disable save group button
      vm.addNewComboGroup = false

      // prepare data for image
      let data = {}
      for (let i in vm.images) {
        data[vm.images[i]] = ''
      }
      vm.item.groups.push({
        name: {},
        uuid: '',
        sequence: 0,
        min: 1,
        max: 1,
        image: {},
        imageData: data,
        active: 1,
        menuItemSelected: [],
        items: [],
        priceStatus: []
      })
      vm.groupStatus[vm.item.groups.length - 1] = true
      vm.groupItemStatus[vm.item.groups.length - 1] = []
      vm.groupHidden[vm.item.groups.length - 1] = true
    },
    resetGroupStatus () {
      for (let gt in vm.groupStatus) {
        vm.groupStatus[gt] = false
      }
    },
    resetGroupItemStatus () {
      for (let gt in vm.groupItemStatus) {
        for (let i in vm.groupItemStatus[gt]) {
          vm.groupItemStatus[gt][i] = false
        }
      }
    },
    resetGroupHidden () {
      for (let gt in vm.groupHidden) {
        vm.groupHidden[gt] = false
      }
    },
    removeGroup (index) {
      let groups = []
      for (let i in vm.item.groups) {
        if (i != index) {
          groups.push(vm.item.groups[i])
        } else {
          if (vm.item.groups[i].uuid != '') {
            vm.deleteGroups.push(vm.item.groups[i].uuid)
          }
        }
      }
      vm.item.groups = groups

      // enable save group button
      vm.addNewComboGroup = true
    },
    removeGroupBK (index) {
      let options = {
        html: true,
        okText: vm.$t('common.delete'),
        cancelText: vm.$t('common.cancel')
      }
      vm.$dialog.confirm(vm.$t('message.delete_confirm'), options)
        .then(function (dialog) {
          let groups = []
          for (let i in vm.item.groups) {
            if (i != index) {
              groups.push(vm.item.groups[i])
            }else{
              if (vm.item.groups[i].uuid != "") {
                vm.axios.menu.deleteComboGroup(vm.item.groups[i].uuid, function(response){})
              }
            }
          }
          vm.item.groups = groups

          // enable save group button
          vm.addNewComboGroup = true
        })
        .catch(function () {
        })
    },
    addItem (group_index) {
      let items = vm.item.groups[group_index].items
      let days = {}
      for (let i in vm.daysOfWeek) {
        days[vm.daysOfWeek[i]] = {
          day: vm.daysOfWeek[i],
          opening: '08:00:00',
          closing: '23:00:00',
          active: 1
        }
      }
      if (items.length == 0) {
        items = [{
          single_id: '',
          opening_times: days,
          special_dates: [],
          prices: [],
          first_layers: []
        }]
      } else {
        items.push({
          single_id: '',
          opening_times: days,
          special_dates: [],
          prices: [],
          first_layers: []
        })
      }
      // vm.item.groups[group_index].items = items
      for (let i = 0; i < items.length; i++) {
        vm.$set(vm.item.groups[group_index].items, i, items[i])
      }
      vm.item.groups[group_index].menuItemSelected[items.length - 1] = ''
      vm.item.groups[group_index].priceStatus[items.length - 1] = true
      vm.groupItemStatus[group_index][items.length - 1] = true
      let _index = items.length - 1
      vm.$forceUpdate('groupItemStatus['+group_index+']'+'['+_index+']')
      vm.isOpenMenuItem = false

      // //enable save group button
      vm.groupHidden[group_index] = true
    },
    copySku (group_index, index) {
      let _menu = vm.item.groups[group_index].items[index]
      if (_menu){
        const el = document.createElement('input')
        el.value = _menu.single.sku
        document.body.appendChild(el)
        el.select()
        document.execCommand('copy')
        document.body.removeChild(el)
      }
    },
    removeItem (group_index, index) {
      let options = {
        html: true,
        okText: vm.$t('common.delete'),
        cancelText: vm.$t('common.cancel')
      }
      vm.$dialog.confirm(vm.$t('message.delete_confirm'), options)
        .then(function (dialog) {
          let items = []
          let menuItemSelectedItems = []
          for (let i in vm.item.groups[group_index].items) {
            if (i != index) {
              items.push(vm.item.groups[group_index].items[i])
              menuItemSelectedItems.push(vm.item.groups[group_index].menuItemSelected[i])
            }
          }
          vm.item.groups[group_index].items = items
          vm.item.groups[group_index].menuItemSelected = menuItemSelectedItems

          // enable save group button
          vm.groupHidden[group_index] = true
        })
        .catch(function () {
        })
    },
    /**
     * upload image then move to next form
     */
    saveComboGroup (group_index) {
      let item = JSON.parse(JSON.stringify(vm.item.groups[group_index]))
      let formData = new FormData()
      let oldUrl = []
      for (let i in vm.item.groups[group_index].image) {
        if (vm.item.groups[group_index].image[i] && vm.item.groups[group_index].image[i].type != undefined) {
          formData.append(i, vm.item.groups[group_index].image[i])
        } else {
          oldUrl[i] = vm.item.groups[group_index].image[i]
        }
      }
      let config = {'Content-Type': 'multipart/form-data'}
      item.min = parseInt(item.min, 10)
      item.max = parseInt(item.max, 10)
      let newItem = item

      // call an API to save imag
      vm.axios.menu.uploadComboImages(formData, config, function (response) {
        if (response.data.status == true) {
          for (let i in response.data.data.item) {
            newItem.image[i] = response.data.data.item[i]
          }
          // get old url
          for (let i in oldUrl) {
            newItem.image[i] = oldUrl[i]
          }
          // get opening times
          for (let i in vm.item.groups[group_index].items) {
            newItem.items[i].opening_times = []
            for (let j in vm.item.groups[group_index].items[i].opening_times) {
              newItem.items[i].opening_times.push(vm.item.groups[group_index].items[i].opening_times[j])
            }
          }
          for (let i in vm.item.groups[group_index]) {
            if (i == 'items' && i != 'menuItemSelected' && i != 'imageData' && i != 'priceStatus') {
              for (let j = 0; j < vm.item.groups[group_index].items.length; j++) {
                // change date for prices
                let prices = []
                for (let k = 0; k < vm.item.groups[group_index].items[j].prices.length; k++) {
                  prices.push({
                    'from': vm.revertDateFormat(vm.item.groups[group_index].items[j].prices[k].from) + ' 00:00:00',
                    'to': vm.revertDateFormat(vm.item.groups[group_index].items[j].prices[k].to) + ' 23:59:59',
                    'price': vm.item.groups[group_index].items[j].prices[k].price,
                    'price_without_tax': vm.item.groups[group_index].items[j].prices[k].price_without_tax,
                    'tax_rate': vm.item.groups[group_index].items[j].prices[k].tax_rate
                  })
                }
                newItem[i][j].prices = prices

                // change date for special prices
                // let special_dates = []
                // for (let k = 0; k < vm.item.groups[group_index].items[j].special_dates.length; k++) {
                //   special_dates.push({
                //     'date': vm.revertDateFormat(vm.item.groups[group_index].items[j].special_dates[k].date),
                //     'active': vm.item.groups[group_index].items[j].special_dates[k].active,
                //     'from': vm.item.groups[group_index].items[j].special_dates[k].from,
                //     'name': vm.item.groups[group_index].items[j].special_dates[k].name,
                //     'status': vm.item.groups[group_index].items[j].special_dates[k].status,
                //     'to': vm.item.groups[group_index].items[j].special_dates[k].to
                //   })
                // }
                // newItem[i][j].special_dates = special_dates

                // change date for first layer
                let first_layers = vm.item.groups[group_index].items[j].first_layers
                for (let k in first_layers) {
                  // prices for first layers
                  let prices = []
                  for (let l in first_layers[k].prices) {
                    prices.push({
                      'from': vm.revertDateFormat(first_layers[k].prices[l].from) + ' 00:00:00',
                      'to': vm.revertDateFormat(first_layers[k].prices[l].to) + ' 23:59:59',
                      'price': first_layers[k].prices[l].price,
                      'price_without_tax': first_layers[k].prices[l].price_without_tax,
                      'tax_rate': first_layers[k].prices[l].tax_rate,
                      'active': first_layers[k].prices[l].active
                    })
                  }
                  newItem[i][j].first_layers[k].prices = prices

                  // prices for second layers
                  let second_layers = first_layers[k].second_layers
                  for (let l in second_layers) {
                    let pricesSeconds = []
                    for (let m in second_layers[l].prices) {
                      pricesSeconds.push({
                        'from': vm.revertDateFormat(second_layers[l].prices[m].from) + ' 00:00:00',
                        'to': vm.revertDateFormat(second_layers[l].prices[m].to) + ' 23:59:59',
                        'price': second_layers[l].prices[m].price,
                        'price_without_tax': second_layers[l].prices[m].price_without_tax,
                        'tax_rate': second_layers[l].prices[m].tax_rate,
                        'active': second_layers[l].prices[m].active
                      })
                    }
                    newItem[i][j].first_layers[k].second_layers[l].prices = pricesSeconds
                  }
                }
              }
            }
          }
          newItem['combo_id'] = vm.item.combo_id
          console.log(newItem)
          // call an API to save combo group information
          // check create or update
          if (newItem.uuid == '') {
            vm.axios.menu.createComboGroup(newItem, function (response) {
              vm.addNewComboGroup = true
              // if success
              // enable save group button
              vm.resetGroupHidden()
              vm.resetGroupStatus()
              vm.resetGroupItemStatus()
              // vm.$toastr.success(vm.$t('message.update_successful'), vm.$t('message.success'), {})

              // update uuid for group
              vm.item.groups[group_index].uuid = response.data.data.item.uuid

              // raise an event to change menu item
              vm.$forceUpdate('item.groups[' + group_index + ']')
              vm.callbackUpdateSuccess(group_index, true)
            }, function (error) {
              vm.callbackUpdateSuccess(group_index, true)
              vm.$toastr.error(vm.$t('combo.group')+ ' '+vm.item.groups[group_index].name[vm.$session.get('lang')] + ' ' + vm.$t('message.update_fail'), vm.$t('message.error'), {})
            })
          } else {
            vm.axios.menu.updateComboGroup(newItem, function (response) {
              for (let l in newItem.menuItemSelected) {
                if (typeof newItem.menuItemSelected[l].text !== "undefined") {
                  newItem.menuItemSelected[l] = newItem.menuItemSelected[l].value
                }
              }
              vm.addNewComboGroup = true
              // if success
              // enable save group button
              vm.resetGroupHidden()
              vm.resetGroupStatus()
              vm.resetGroupItemStatus()
              // vm.$toastr.success(vm.$t('message.update_successful'), vm.$t('message.success'), {})

              // update uuid for group
              vm.item.groups[group_index].uuid = response.data.data.item.uuid

              // raise an event to change menu item
              vm.$forceUpdate('item.groups[' + group_index + ']')
              vm.callbackUpdateSuccess(group_index, true)
            }, function (error) {
              vm.callbackUpdateSuccess(group_index, false)
              vm.$toastr.error(vm.$t('combo.group')+ ' '+vm.item.groups[group_index].name[vm.$session.get('lang')] + ' ' + vm.$t('message.update_fail'), vm.$t('message.error'), {})
            })
          }
          vm.$forceUpdate('groupStatus')
          vm.$forceUpdate('groupHidden')
        }
      }, function (response) {
        vm.$bus.$emit('loading', 'none')
      })
    },
    callbackUpdateSuccess (index, status) {
      this.countProccess++
      if (!status) {
        this.flagProccess = false
      }
      if (vm.item.groups.length == this.countProccess) {
        // remove loading
        vm.$bus.$emit('loading', 'none')
        if (this.flagProccess) {
          vm.$toastr.success(vm.$t('message.update_successful'), vm.$t('message.success'), {})
        }
      }
    },
    finishCreateComboGroup () {
      this.countProccess = 0
      this.flagProccess = true
      this.$bus.$emit('loading', 'block')
      for (let i in vm.deleteGroups) {
        vm.axios.menu.deleteComboGroup(vm.deleteGroups[i], function(response){})
      }
      for (let i in vm.item.groups) {
        this.saveComboGroup(i)
      }
    },
    /**
     * convert date from YYYY-MM-DD to DD-MM-YYYY
     * @param val
     * @returns {*}
     */
    convertDateFormat (val) {
      return this.$moment(val, 'YYYY-MM-DD').format('DD-MM-YYYY')
    },
    /**
     * revert date from DD-MM-YYYY to YYYY-MM-DD
     * @param val
     * @returns {*}
     */
    revertDateFormat (val) {
      return this.$moment(val, 'DD-MM-YYYY').format('YYYY-MM-DD')
    },
    getMenuList () {
      // get params
      let _data = {
        limit: vm.itemLimit,
        active: 1
      }
      // process to send via get method
      let params = ''
      for (let key in _data) {
        params += key + '=' + _data[key] + '&'
      }
      // remove tail
      params = params.slice(0, -1)
      vm.axios.menu.getMenuListForCombobox(params,
        function (response) {
          let langs = vm.$store.getters.languages
          for (let l in langs) {
            let lang = langs[l]
            vm.menuItems[lang] = []
            for (let c in response.data.data.items) {
              let item = response.data.data.items[c]
              if (item['name'] != null && item['name'][lang] != undefined && item['name'][lang] != '') {
                vm.menuItems[lang].push({
                  value: item['uuid'],
                  text: item['name'][lang] + ' | ' + item['sku'],
                  name: item['name'][lang],
                  sku: item['sku'],
                  selling_end: item.selling_end,
                  selling_start: item.selling_start
                })
              } else {
                vm.menuItems[lang].push({
                  value: item['uuid'],
                  text: 'Invalid Name (' + item['sku'] + ')',
                  sku: item['sku'],
                  selling_end: item.selling_end,
                  selling_start: item.selling_start
                })
              }
            }
          }
        }
      )
    },
    getFirstLayerOptions() {
      let params = 'active=1'
      vm.axios.menu.getFirstLayerList(params, function (response) {
        vm.first_layer_options = response.data.data.items
      })
    },
    getSecondLayerOptions() {
      let params = 'active=1'
      vm.axios.menu.getSecondLayerList(params, function (response) {
        vm.second_layer_options = response.data.data.items
      })
    },
    updateFirstLayerItems (indexGroup, indexItem, indexFirst, event, lang) {
      let first_layer

      if (lang === undefined) {
        first_layer = this.first_layer_options.find(f => f.sku === event)
      } else {
        first_layer = this.first_layer_options.find(f => f.name[lang] === event)
      }

      if (first_layer) {
        for (let i in vm.$store.getters.languages) {
          if (vm.$store.getters.languages.hasOwnProperty(i)) {
            vm.item.groups[indexGroup].items[indexItem].first_layers[indexFirst].name[vm.$store.getters.languages[i]] = first_layer.name[vm.$store.getters.languages[i]]
          }
        }
        vm.item.groups[indexGroup].items[indexItem].first_layers[indexFirst].sku = first_layer.sku
        vm.item.groups[indexGroup].items[indexItem].first_layers[indexFirst].first_id = first_layer.id
        vm.item.groups[indexGroup].items[indexItem].first_layers[indexFirst].short_name = first_layer.short_name
      }
    },
    updateSecondLayerItems (indexGroup, indexItem,indexFirstLayer, indexSecondLayer, event, lang) {
      let second_layer
      if (lang === undefined) {
        second_layer = vm.second_layer_options.find(s => s.sku === event)
      } else {
        second_layer = vm.second_layer_options.find(s => s.name[lang] === event)
      }

      if (second_layer) {
        for (let i in vm.$store.getters.languages) {
          if (vm.$store.getters.languages.hasOwnProperty(i)) {
            vm.item.groups[indexGroup].items[indexItem].first_layers[indexFirstLayer].second_layers[indexSecondLayer].name[vm.$store.getters.languages[i]] = second_layer.name[vm.$store.getters.languages[i]]
          }
        }
        vm.item.groups[indexGroup].items[indexItem].first_layers[indexFirstLayer].second_layers[indexSecondLayer].sku = second_layer.sku
        vm.item.groups[indexGroup].items[indexItem].first_layers[indexFirstLayer].second_layers[indexSecondLayer].second_id = second_layer.id
        vm.item.groups[indexGroup].items[indexItem].first_layers[indexFirstLayer].second_layers[indexSecondLayer].short_name = second_layer.short_name
      }
    },
  },
  created: function () {
    vm = this
    vm.getFirstLayerOptions()
    vm.getSecondLayerOptions()
    vm.getMenuList()
  },
  mounted: function () {
    // prepare data for image
    let data = {}
    for (let i in vm.images) {
      data[vm.images[i]] = ''
    }

    let priceDefault = {}
    for (let t in vm.tier) {
      priceDefault[t] = 0
    }
    vm.imageData = data

    vm.axios.menu.getComboDetail(vm.uuid, function (response) {
      vm.item.combo_id = response.data.data.item.id
      vm.item.combo_uuid = response.data.data.item.uuid

      if (response.data.data.item.groups.length > 0) {
        vm.isCreate = false
      } else {
        vm.isCreate = true
      }
      for (let i = 0; i < response.data.data.item.groups.length; i++) {
        vm.groupItemStatus[i] =[]
        vm.$set(vm.item.groups, i, response.data.data.item.groups[i])
        // prepare data for image
        let data = {}
        for (let x in vm.images) {
          data[vm.images[x]] = ''
        }
        // load old image of specific group
        for (let x in response.data.data.item.groups[i].image) {
          data[x] = response.data.data.item.groups[i].image[x]
        }
        vm.item.groups[i].image = response.data.data.item.groups[i].image
        vm.item.groups[i].imageData = data
        vm.item.groups[i].menuItemSelected = []
        vm.item.groups[i].priceStatus = []

        for (let j = 0; j < vm.item.groups[i].items.length; j++) {
          vm.groupItemStatus[i][j] = false
          // let productName = vm.item.groups[i].items[j].single.name[vm.$session.get('lang')]
          // if (vm.item.groups[i].items[j].single.uuid && productName !== '' && productName !== undefined) {
          // vm.$set(vm.item.groups[i].menuItemSelected, j, vm.item.groups[i].items[j].single.uuid)
          // console.log('lang', m.item.groups[i].items[j].name[vm.$session.get('lang')])
          vm.item.groups[i].menuItemSelected[j] = {
            text: vm.item.groups[i].items[j].single.name[vm.$session.get('lang')] + ' | ' + vm.item.groups[i].items[j].single.sku,
            value: vm.item.groups[i].items[j].single.uuid
          }
          // }
          // else{
          //     vm.$set(vm.item.groups[i].menuItemSelected, j, "")
          // }

          // change date for opening hours
          let opening_times = vm.item.groups[i].items[j].opening_times
          vm.item.groups[i].items[j].opening_times = []
          for (let k = 0; k < opening_times.length; k++) {
            let it = opening_times[k]
            vm.item.groups[i].items[j].opening_times[it.day] = it
          }

          // change date for special dates
          let special_dates = vm.item.groups[i].items[j].special_dates
          vm.item.groups[i].items[j].special_dates = []
          for (let k = 0; k < special_dates.length; k++) {
            vm.item.groups[i].items[j].special_dates.push({
              'date': vm.convertDateFormat(special_dates[k].date),
              'active': special_dates[k].active,
              'from': special_dates[k].from,
              'name': special_dates[k].name,
              'status': special_dates[k].status,
              'to': special_dates[k].to
            })
          }

          // change date for prices
          let prices = vm.item.groups[i].items[j].prices
          vm.item.groups[i].items[j].prices = []
          if (prices.length > 0) {
            for (let k = 0; k < prices.length; k++) {
              vm.item.groups[i].items[j].prices.push({
                'from': vm.convertDateFormat(prices[k].from),
                'to': vm.convertDateFormat(prices[k].to),
                'price':  vm.formatPriceByTier(prices[k].price,vm.tier),
                'price_without_tax': vm.formatPriceByTier(prices[k].price_without_tax,vm.tier),
                'tax_rate': prices[k].tax_rate != null ? prices[k].tax_rate : 0
              })
            }
          } else {
            vm.item.groups[i].items[j].prices.push({
              from: defaultDateFrom,
              to: defaultDateTo,
              price: priceDefault,
              price_without_tax: priceDefault,
              tax_rate: 0,
              active: 1
            })
          }

          // change date for first layer
          let first_layers = vm.item.groups[i].items[j].first_layers
          for (let k = 0; k < first_layers.length; k++) {
            // prices for first layers
            let prices = []
            if (first_layers[k].prices.length > 0) {
              for (let l in first_layers[k].prices) {
                prices.push({
                  'from': vm.convertDateFormat(first_layers[k].prices[l].from),
                  'to': vm.convertDateFormat(first_layers[k].prices[l].to),
                  'price': vm.formatPriceByTier(first_layers[k].prices[l].price,vm.tier),
                  'price_without_tax': vm.formatPriceByTier(first_layers[k].prices[l].price_without_tax ,vm.tier),
                  'tax_rate': first_layers[k].prices[l].tax_rate != null ? first_layers[k].prices[l].tax_rate : 0,
                  'active': first_layers[k].prices[l].active
                })
              }
            } else {
              prices.push({
                from: defaultDateFrom,
                to: defaultDateTo,
                price: priceDefault,
                price_without_tax: priceDefault,
                tax_rate: 0,
                active: 1
              })
            }
            vm.item.groups[i].items[j].first_layers[k].prices = prices

            // prices for second layers
            let second_layers = first_layers[k].second_layers
            for (let l in second_layers) {
              let pricesSeconds = []
              if (second_layers[l].prices.length > 0) {
                for (let m in second_layers[l].prices) {
                  pricesSeconds.push({
                    'from': vm.convertDateFormat(second_layers[l].prices[m].from),
                    'to': vm.convertDateFormat(second_layers[l].prices[m].to),
                    'price': vm.formatPriceByTier(second_layers[l].prices[m].price,vm.tier),
                    'price_without_tax': vm.formatPriceByTier(second_layers[l].prices[m].price_without_tax,vm.tier),
                    'tax_rate': second_layers[l].prices[m].tax_rate != null ? second_layers[l].prices[m].tax_rate : 0,
                    'active': second_layers[l].prices[m].active
                  })
                }
              } else {
                pricesSeconds.push({
                  from: defaultDateFrom,
                  to: defaultDateTo,
                  price: priceDefault,
                  price_without_tax: priceDefault,
                  tax_rate: 0,
                  active: 1
                })
              }
              vm.item.groups[i].items[j].first_layers[k].second_layers[l].prices = pricesSeconds
            }
          }

          // if (prices.length > 0) {
          vm.item.groups[i].priceStatus[j] = true
          // }
          // else{
          //     vm.item.groups[i].priceStatus[j] = false
          // }
        }
      }
      vm.$forceUpdate('item.groups')
      if (vm.item.groups.length <= 0) {
        vm.groupHidden = [true]
      }
    })
  }
}
</script>

<style scoped>
  .form-control:disabled, .form-control[readonly] {
    background-color: #e4e5e6 !important;
    opacity: 1;
  }
  .option-first input:disabled {
    background-color: #cccccc !important;
  }
    .card-header
    {
        cursor: pointer;
    }

    .notice{
        color: red;
    }

    .group-header,
    .group-header .btn-info{
        background-color: #6c757d !important;
        color: #fff
    }

    .card .card-body .row{
        margin-left: 0;
        margin-right: 0;
    }

    .card-header .btn{
        margin-top: 0 !important;
    }

    /*.title{
        font-style: italic;
        text-decoration: underline;
    }*/

    .menu-item-content{
        width: 100%;
      margin-left: -5px;
      margin-top: -5px;
    }

    .menu-item-content .card-body{
        padding: 10px;
    }

    .crush-size,
    .btn-add-new-group{
        margin-top: 10px;
    }

    .input-group-text .custom-checkbox {
        margin-right: 0px;
        padding-left: 1.0rem;
    }

    .input-group-text {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        padding: 0.375rem 0.75rem;
        margin-bottom: 0;
        font-size: 0.875rem;
        font-weight: 400;
        line-height: 1.5;
        color: #3e515b;
        text-align: center;
        white-space: nowrap;
        background-color: #f8f9fa;
        border: 1px solid #e4e5e6;
    }
    /*.row,*/
    /*.col-12{*/
        /*margin-left: 0;*/
        /*margin-right: 0;*/
        /*padding-left: 0;*/
        /*padding-right: 0;*/
    /*}*/

    .card-body{
        padding: .25rem;
    }

  .preview-image {
    width: 100%;
  }
  .timeline {
    margin-top: 30px;
    padding-left: 15px;
    padding-right: 15px;
  }
  .points {
    width: 100%;
    height: 30px;
    font-size: 30px;
    position: relative;
    z-index: 1;
  }
  .points i {
    position: absolute;
  }
  .step-commit {
    margin-left: calc(0% - 10px);
  }
  .step-updated {
    margin-left: calc(33% - 15px);
  }
  .step-publishing {
    margin-left: calc(66% - 15px);
  }
  .step-publish {
    margin-left: calc(100% - 20px);
  }
  .line-1 {
    position: absolute;
    margin-left: 15px;
    width: calc(33% - 30px);
    height: 1px;
    border: 1px solid #4dbd74 !important;
    margin-top: 15px;
    z-index: 0;
  }
  .line-2 {
    position: absolute;
    margin-left: calc(33% + 15px);
    width: calc(33% - 30px);
    height: 1px;
    border: 1px solid #4dbd74 !important;
    margin-top: 15px;
    z-index: 0;
  }
  .line-3 {
    position: absolute;
    margin-left: calc(66% + 15px);
    width: calc(33% - 30px);
    height: 1px;
    border: 1px solid #4dbd74 !important;
    margin-top: 15px;
    z-index: 0;
  }
  .current-point {
    font-size: 30px;
  }
  .img-min-height {
    min-height: 161px;
  }
  .custom-checkbox {
    padding-left: 0px;
  }

  .menu-item-ddl{
    margin-bottom: 10px;
  }
  .fa.fa-trash-o, .fa.fa-files-o{
    font-size: 30px;
    line-height: 35px;
  }
  .f-s-23{
    font-size: 23px;
  }
    .form-control:focus {
      color: #3e515b;
      background-color: #fff;
      border-color: #8ad4ee;
      outline: 0;
      -webkit-box-shadow: 0 0 0 0.2rem rgba(32, 168, 216, 0.25);
      box-shadow: 0 0 0 0.2rem rgba(32, 168, 216, 0.25);
    }
    .form-control {
      display: block;
      width: 100%;
      padding: 0.375rem 0.75rem;
      font-size: 0.875rem;
      line-height: 1.5;
      color: #3e515b;
      background-color: #fff;
      background-clip: padding-box;
      border: 1px solid #e4e5e6;
      border-radius: 0;
      -webkit-transition: border-color 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
      transition: border-color 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
      transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
      transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
    }
  .pt-10 {
    padding-top: 10px;
  }
    .menu-item-content .card-header{
      background: rgb(225, 230, 235) !important;
      color: black;
    }
    .size-label {
      width: auto;
      padding-right: 10px;
      height: 35px;
      line-height: 35px;
      font-weight: 600;
    }
    .size-name-input {
      flex: 1;
      padding-left: 5px;
      padding-right: 5px;
    }
    .size-code-input {
      flex: 1;
      padding-left: 5px;
      padding-right: 5px;
    }
    .size-price-input {
      flex: 1;
      padding-left: 5px;
      padding-right: 5px;
    }
    .size-active {
      padding-top: 5px;
      text-align: center;
    }
    .size-remove {
      text-align: center;
      font-size: 20px;
      line-height: 35px;
      cursor: pointer;
    }
    .option-first {
      border-top-left-radius: 4px;
      border-top-right-radius: 4px;
      background: #e1e6eb;
      padding: 20px;
    }
    .second-box {
      background: #fff;
      border-radius: 4px;
      border: 1px solid #ccc;
      padding: 15px;
      margin-bottom: 15px;
    }
    .option-second {
      border-bottom-left-radius: 4px;
      border-bottom-right-radius: 4px;
      background: #f5f7f9;
      padding: 20px 15px 0 15px;
    }
    .second-header {
      line-height: 30px;
    }
  .remove-section{
    font-size: 20px;
    line-height: 35px;
    cursor: pointer;
  }
    .option-first {
      border-top-left-radius: 4px;
      border-top-right-radius: 4px;
      background: #e1e6eb;
      padding: 20px;
    }
    .second-box {
      background: #fff;
      border-radius: 4px;
      border: 1px solid #ccc;
      padding: 15px;
      margin-bottom: 15px;
    }
    .option-second {
      border-bottom-left-radius: 4px;
      border-bottom-right-radius: 4px;
      background: #f5f7f9;
      padding: 20px 15px 0 15px;
    }
    .second-header {
      line-height: 30px;
    }
    .option-box {
      padding-bottom: 15px;
    }
    .combo-form .card-footer{
      position: fixed;
      bottom: 0;
      left: 0;
      right: 0;
      padding: 7.75px;
      border-top: none;
      margin-top: 1.5rem;
      z-index: 999;
    }
    .combo-form .btn-save{
      float: right;
      margin-right: 22px;
    }
    .close-btn {
      font-size: 20px;
      cursor: pointer;
      float: right;
    }
    .close-btn .fa-angle-right {
      margin-right: -4px;
    }
    .close-btn .fa-angle-left {
      margin-left: -4px;
    }
    .bg-main{
      background: #0091ff !important;
    }
  .combo-form .add-more-size{
    margin-left: -20px;
  }
  .m-l--20{
    margin-left: -20px;
  }
  .m-l--15{
    margin-left: -15px;
  }
  .width-90 {
    width: 90% !important;
  }
</style>
<style>

  /*.item[data-vss-custom-attr="selling-attr"] {*/
    /*color: red !important;*/
  /*}*/
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
  .multiselect__option--highlight {
    background: #1DE9B6 !important;
  }
</style>



// WEBPACK FOOTER //
// src/views/admin/combo/GroupBaseForm.vue